"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeSearch = void 0;
exports.default = _default;

var _encode = require("./encode");

var _renameField = _interopRequireDefault(require("./rename-field"));

var _assign = _interopRequireDefault(require("lodash/assign"));

var _summary = _interopRequireDefault(require("./summary"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var decoders = [(0, _renameField.default)('K', 'keywords'), (0, _renameField.default)('WH', 'where'), (0, _renameField.default)('WID', 'whereid'), (0, _renameField.default)('I', 'classification'), (0, _renameField.default)('O', 'subclassification'), (0, _renameField.default)('SORT', 'sortmode'), (0, _renameField.default)('D', 'daterange'), (0, _renameField.default)('W', 'worktype'), (0, _renameField.default)('N', 'page'), (0, _renameField.default)('CID', 'companyid'), (0, _renameField.default)('NA', 'nation'), (0, _renameField.default)('L', 'location'), (0, _renameField.default)('A', 'area'), (0, _renameField.default)('ADV', 'advertiserid'), (0, _renameField.default)('ADG', 'advertisergroup'), function decodeSalaryType(_ref) {
  var SL = _ref.SL;
  return SL ? {
    salarytype: SL.toLowerCase()
  } : {};
}, function decodeSalaryRange(_ref2) {
  var SF = _ref2.SF,
      ST = _ref2.ST;
  return SF && ST ? {
    salaryrange: "".concat(SF, "-").concat(ST)
  } : {};
}, function decodeGraduateSearch(_ref3) {
  var C = _ref3.C;
  return C ? {
    graduatesearch: 'true'
  } : {};
}];

var deserialiseCookie = function deserialiseCookie(cookie) {
  var cookieParts = cookie.split('~').map(function (encoded) {
    var parts = encoded.split('|');
    var key = parts[0];
    var value = parts.slice(1).join('|');
    return value ? {
      [key]: value
    } : {};
  });
  return _assign.default.apply(void 0, _toConsumableArray(cookieParts));
};

var parseTimestamp = function parseTimestamp(cookie) {
  var timestamp = cookie.OSF && cookie.OSF.split('=')[1];
  return timestamp && /^\d+$/.test(timestamp) ? parseInt(timestamp, 10) : null;
};

var decodeSearch = function decodeSearch(cookie, locale) {
  var decodedCookie;

  try {
    decodedCookie = decodeURIComponent(cookie);
  } catch (e) {
    decodedCookie = cookie;
  }

  var deserialisedCookie = deserialiseCookie(decodedCookie);
  var decodedParts = decoders.map(function (decode) {
    return decode(deserialisedCookie);
  });

  var query = _assign.default.apply(void 0, _toConsumableArray(decodedParts));

  var timestamp = parseTimestamp(deserialisedCookie);

  if (!timestamp) {
    return null;
  }

  return {
    query,
    date: new Date(timestamp),
    summary: (0, _summary.default)(query, locale)
  };
};

exports.decodeSearch = decodeSearch;

function _default(cookie, locale) {
  if (!cookie) {
    return null;
  }

  var parsedSearches = cookie.split(_encode.searchSeparator).map(function (search) {
    return decodeSearch(search, locale);
  }).filter(Boolean);

  var _ref4 = parsedSearches[0] || {},
      parsedQuery = _ref4.query,
      parsedDate = _ref4.date,
      parsedSummary = _ref4.summary;

  return parsedSearches.length > 0 ? {
    query: parsedQuery,
    date: parsedDate,
    summary: parsedSummary,
    searches: parsedSearches
  } : null;
}